var _circle, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnSk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "url(#paint0_linear_3392_54701)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.10051 11.2613C8.51704 10.9979 8.03578 10.784 8.03578 10.3477C8.03578 10.0185 8.30835 9.77572 8.84923 9.77572C9.0494 9.77572 9.21124 9.80041 9.37734 9.82922C9.46678 9.84568 9.56048 9.85802 9.63714 9.85802C10.1099 9.85802 10.3782 9.58642 10.5528 9.0679L10.6252 8.85802C10.5486 8.82922 9.77768 8.5 8.76831 8.5C7.16695 8.5 6.31942 9.49177 6.31942 10.5247C6.31942 11.0432 6.48552 11.4218 6.74957 11.7181C7.09029 12.1008 7.57581 12.3477 8.02726 12.5617C8.68739 12.8745 9.28365 13.1049 9.28365 13.57C9.28365 13.9815 8.84497 14.216 8.25724 14.216C7.4523 14.216 6.74532 13.7716 6.65588 13.7181L6 14.9115C6.11925 14.9774 6.97104 15.5 8.37223 15.5C9.86712 15.5 11 14.6728 11 13.3971C11 12.1296 9.9523 11.6564 9.10051 11.2613Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0806 11.8053L17.8562 8.5H15.878L13.6645 11.3525H13.6296V8.5H12V15.5H12.0959C12.7974 15.5 13.6383 15.1826 13.6383 14.0399V12.4317H13.6688L15.9259 15.4111H18L15.0806 11.8053Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3392_54701",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED2128"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46929"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnSk);
export default __webpack_public_path__ + "static/media/unSK.a5ca0736a82b3483efd8bb0660bf6476.svg";
export { ForwardRef as ReactComponent };